/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Action } from '@ngrx/store';
import { User, Menu, Widget, Dashboard, ProgressIndicator } from '@api/models';
import { Route } from '@angular/router';

export const LOAD_MENU = '[UI] Load menu';
export const LOAD_MENU_SUCCESS = '[UI] Load menu success';
export const LOAD_MENU_FAIL = '[UI] Load menu fail';

export const LOAD_ROUTE = '[UI] Load route';
export const LOAD_ROUTE_SUCCESS = '[UI] Load route success';
export const LOAD_ROUTE_FAIL = '[UI] Load route fail';

export const LOAD_DASHBOARD_MENU = '[UI] Load dashboard menu';
export const LOAD_DASHBOARD_MENU_SUCCESS = '[UI] Load dashboard menu success';
export const LOAD_DASHBOARD_MENU_FAIL = '[UI] Load dashboard menu fail';

export const LOAD_DASHBOARD = '[UI] Load dashboard';
export const LOAD_DASHBOARD_SUCCESS = '[UI] Load dashboard success';
export const LOAD_DASHBOARD_FAIL = '[UI] Load dashboard fail';

export const OPEN_SIDENAV = '[UI] Open Sidenav';
export const CLOSE_SIDENAV = '[UI] Close Sidenav';
export const TOGGLE_SIDENAV = '[UI] Toggle Sidenav';

export const GOTO_THEME = '[UI] Goto theme';
export const GOTO_THEME_SUCCESS = '[UI] Goto theme success';
export const GOTO_THEME_FAIL = '[UI] Goto theme fail';

export const SHOW_TOAST = '[UI] Show toast';

export const SHOW_PROGRESS_INDICATOR = '[UI] Show progress indicator';

/**
 * Load menu action
 */
export class LoadMenuAction implements Action {
  readonly type = LOAD_MENU;
  /**
   * 
   * @param payload User
   */
  constructor(public payload: User) { }
}

/**
 * Load menu success action
 */
export class LoadMenuSuccessAction implements Action {
  readonly type = LOAD_MENU_SUCCESS;
  /**
   * 
   * @param payload Menu items
   */
  constructor(public payload: Menu[]) { }
}

/**
 * Load menu fail action
 */
export class LoadMenuFailAction implements Action {
  readonly type = LOAD_MENU_FAIL;
  /**
   * 
   * @param payload error
   */
  constructor(public payload: string) { }
}

/**
 * Load route action
 */
export class LoadRouteAction implements Action {
  readonly type = LOAD_ROUTE;
  /**
   * 
   * @param payload User
   */
  constructor(public payload: User) { }
}

/**
 * Configure router success action
 */
export class LoadRouteSuccessAction implements Action {
  readonly type = LOAD_ROUTE_SUCCESS;
  /**
   * 
   * @param payload Route items
   */
  constructor(public payload: Route[]) { }
}

/**
 * Configure router fail action
 */
export class LoadRouteFailAction implements Action {
  readonly type = LOAD_ROUTE_FAIL;
  /**
   * 
   * @param payload error
   */
  constructor(public payload: string) { }
}

/**
 * Load dashboard menu action
 */
export class LoadDashboardMenuAction implements Action {
  readonly type = LOAD_DASHBOARD_MENU
}

/**
 * Load dashboard menu success action
 */
export class LoadDashboardMenuSuccessAction implements Action {
  readonly type = LOAD_DASHBOARD_MENU_SUCCESS;
  /**
   * 
   * @param payload Widget items
   */
  constructor(public payload: Dashboard[]) { }
}

/**
 * Load dashboard menu fail action
 */
export class LoadDashboardMenuFailAction implements Action {
  readonly type = LOAD_DASHBOARD_MENU_FAIL;
  /**
   * 
   * @param payload error
   */
  constructor(public payload: string) { }
}

/**
 * Load dashboard action
 */
export class LoadDashboardAction implements Action {
  readonly type = LOAD_DASHBOARD;
  /**
   * 
   * @param payload url
   */
  constructor(public payload: string) { }
}

/**
 * Load dashboard success action
 */
export class LoadDashboardSuccessAction implements Action {
  readonly type = LOAD_DASHBOARD_SUCCESS;
  /**
   * 
   * @param payload Widget items
   */
  constructor(public payload: Widget[]) { }
}

/**
 * Load dashboard fail action
 */
export class LoadDashboardFailAction implements Action {
  readonly type = LOAD_DASHBOARD_FAIL;
  /**
   * 
   * @param payload error
   */
  constructor(public payload: string) { }
}

/**
 * Open sidenav
 */
export class OpenSidenavAction implements Action {
  readonly type = OPEN_SIDENAV;
}

/**
 * Close sidenav
 */
export class CloseSidenavAction implements Action {
  readonly type = CLOSE_SIDENAV;
}

/**
 * Toggle sidenav
 */
export class ToggleSidenavAction implements Action {
  readonly type = TOGGLE_SIDENAV;
}

/**
 * Goto theme action
 */
export class GotoThemeAction implements Action {
  readonly type = GOTO_THEME;
  /**
   * 
   * @param payload theme
   */
  constructor(public payload: string) { }
}

/**
 * Goto theme success action
 */
export class GotoThemeSuccessAction implements Action {
  readonly type = GOTO_THEME_SUCCESS;
  /**
   * 
   * @param payload theme
   */
  constructor(public payload: string) { }
}

/**
 * Goto theme fail action
 */
export class GotoThemeFailAction implements Action {
  readonly type = GOTO_THEME_FAIL;
  /**
   * 
   * @param payload error
   */
  constructor(public payload: string) { }
}

/**
 * Goto theme fail action
 */
export class ShowToastAction implements Action {
  readonly type = SHOW_TOAST;
  /**
   * 
   * @param payload { message: string, title?: string, type: "info" | "success" | "error" | "warning" }
   */
  constructor(public payload: { message: string, title?: string, type: "info" | "success" | "error" | "warning" }) { }
}

/**
 * Show/hide progress indicator for long running operations action
 */
export class ShowProgressIndicatorAction implements Action {
  readonly type = SHOW_PROGRESS_INDICATOR;
  /**
   * 
   * @param payload ProgressIndicator
   */
  constructor(public payload: ProgressIndicator) { }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/actions/ui.actions.ts